import { Icons } from '@/assets/icons/icons';
import { XStack, YStack } from '@/components/ui/layout/layout';

export function DialogHeader({
  icon,
  title,
  subtitle,
  badges,
  onBack,
}: {
  icon?: React.ReactNode;
  title: string;
  subtitle?: React.ReactNode;
  badges?: React.ReactNode;
  onBack?: () => void;
}) {
  return (
    <div className="p-6 pb-0">
      <XStack className="items-start gap-3 pr-8">
        {onBack && (
          <button
            type="button"
            title="Back"
            onClick={onBack}
            className="mt-1 flex size-7 shrink-0 items-center justify-center rounded-md text-foreground-muted hover:bg-surface-hover hover:text-foreground"
          >
            <Icons.chevronLeft className="size-4" />
          </button>
        )}
        {icon && (
          <div className="flex size-9 shrink-0 items-center justify-center rounded-lg border border-border-strong bg-surface text-foreground">
            {icon}
          </div>
        )}
        <YStack className="min-w-0 flex-1">
          <XStack className="items-center gap-2">
            <h2 className="text-lg font-medium leading-tight tracking-tight">
              {title}
            </h2>
            {badges}
          </XStack>
          {subtitle && (
            <div className="mt-0.5 text-xs leading-snug text-foreground-muted">
              {subtitle}
            </div>
          )}
        </YStack>
      </XStack>
    </div>
  );
}
